import { Injectable } from '@angular/core';
import { FlashMessagesService } from 'angular2-flash-messages';
import { AuthService } from '../../shared/auth/auth.service';
import { Router } from '@angular/router';
import { Subject } from 'rxjs/Subject';
import * as FileSaver from 'file-saver'
//import * as FileSaver from 'file-saver';
import { ApiService } from '../api-service/api.service';

@Injectable()
export class HelpersService { 

  constructor(private flashMessagesService: FlashMessagesService,
              private router: Router,
              private api: ApiService,
              private auth: AuthService) { }

  PERMISSION_SERVICES: any = [
    { code: 'RED00', name:'Account Management', icon: 'fa-user', color: 'bg-red' },
    { code: 'RED01', name:'Sub Users Management', icon: 'fa-users', color: 'bg-blue' },
    { code: 'RED02', name:'User Account Management', icon: 'fa-smile-o', color: 'bg-green' },
   /* { code: 'RED03', name:'', icon: 'fa-envelope', color: 'bg-red' },
    { code: 'RED04', name:'', icon: 'fa-users', color: 'bg-black' },
    { code: 'RED05', name:'', icon: 'fa-sitemap', color: 'bg-green' },
    { code: 'RED06', name:'', icon: 'fa-file-text-o', color: 'bg-blue' },
    { code: 'RED07', name:'', icon: 'fa-gear', color: 'bg-red' },*/
  ];

  AllowedFileTypes:any[] = 
      ['xlsx',
      'xls',
      'ods',
      'odt',
      'odp',
      'xla',
      'xlt',
      'text/csv',
      'application/csv',
      'application/excel',
      'application/vnd.ms-excel',
      'application/vnd.msexcel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'application/vnd.oasis.opendocument.spreadsheet',
      'application/vnd.ms-excel'];


  tempContactList:any = [];


  loading_uploads: Subject<any> = new Subject<any>();
  validContacts: Subject<any> = new Subject<any>();
  duplicateContacts: Subject<any> = new Subject<any>();
  failedContacts: Subject<any> = new Subject<any>();
  rawContacts: Subject<any> = new Subject<any>();
  rawContactsLenght: Subject<any> = new Subject<any>();
  uploading_contacts: Subject<any> = new Subject<any>();

  show_activate_phone: Subject<any> = new Subject<any>();



//CHECK IF THE CURRENT USER HAS THE SPECIFIED PERMISSION
  hasAuth(auth_keys:any){
    var available_permissions = [];
    var user = this.auth.user();
    if(this.auth.isLoggedIn() && user.profile.profilename == 'Full')
    {
      return true;
    }
    
    auth_keys.forEach(function(auth_key) {
  
      var check_permission = auth_key.split("-");

      if(user.profile.permissions.filter(
        temp_permission => temp_permission.serviceauthitemid === check_permission[0] &&
                           temp_permission[check_permission[1]] === true
      ).length > 0){
  
        available_permissions.push(auth_key);
      
      }
    });

    if(available_permissions.length > 0){

      return true;
    
    }else{
    
      return false;
    
    }

    
  }


  setTempContact(contact:any){

    if(this.tempContactList.filter(
      temp_contact => temp_contact.userContactListPK.msisdn === contact.userContactListPK.msisdn
    ).length > 0){
      
    }else{
      //push prepared data into the tempContactList
      this.tempContactList.push(contact);
    }

  }


  getServiceIcon(code: string) {

    if (this.PERMISSION_SERVICES.find(service => service.code == code)) {
      return this.PERMISSION_SERVICES.find(service => service.code == code);
    } else {
      return { code: '', icon: 'fa-gears', color: 'bg-blue' };
    }

  }


 flashTimeout: any = 5000;

  flashSuccess(message: string) {
    window.scrollTo(0, 0);
    this.flashMessagesService.show(message, { cssClass: 'alert-success animated fadeInLeft', timeout: this.flashTimeout });

  }

  flashSuccessCustom(message: string,flashTimeout:number) {
    window.scrollTo(0, 0);
    this.flashMessagesService.show(message, { cssClass: 'alert-success animated fadeInLeft', timeout: flashTimeout });

  }




  flashInfo(message: string) {
    window.scrollTo(0, 0);
    this.flashMessagesService.show(message, { cssClass: 'alert-info animated fadeInDown', timeout: this.flashTimeout });

  }




  flashWarning(message: string) {
    window.scrollTo(0, 0);
    this.flashMessagesService.show(message, { cssClass: 'alert-warning animated fadeInDown', timeout: this.flashTimeout });

  }

  flashWarningCustom(message: string,flashTimeout:number) {
    window.scrollTo(0, 0);
    this.flashMessagesService.show(message, { cssClass: 'alert-warning animated fadeInDown', timeout: flashTimeout });

  }




  flashDanger(message: string) {
    window.scrollTo(0, 0);
    this.flashMessagesService.show(message, { cssClass: 'alert-danger animated fadeInDown', timeout: this.flashTimeout });

  }


  redirectTo(uri:string){
    this.router.navigateByUrl('/DummyComponent', {skipLocationChange: true}).then(()=>
    this.router.navigate([uri]));
  }


  sleep (time) {
    return new Promise((resolve) => setTimeout(resolve, time));
  }




  ///// ==========================================================================///////////
  ///// ===========           CONTACT UPLOAD HELPERS             =================///////////
  ///// ==========================================================================///////////
  //==Read Contacts
  contactsUploaded(groupid){
    //Fetch the json string sent to the hidden input and parse it back to json object
    //Set the global varriables
    var rawContacts = JSON.parse(document.getElementById("uploaded_contacts").innerText);
    var rawContactsLenght = rawContacts.length;

    //send back the values collected
    this.rawContacts.next(rawContacts);
    this.rawContactsLenght.next(rawContactsLenght);

    //Start the validation worker
    var validate_contacts_worker;
    if(typeof(Worker) !== "undefined") {
      if(typeof(validate_contacts_worker) == "undefined") {
        validate_contacts_worker = new Worker("assets/workers/validate_contacts.js");

        let validate_contact_payload = {
          'userid': this.auth.user().userid,
          'rawContacts': rawContacts
        };

        if(groupid){
          validate_contact_payload['groupid']       = groupid;
        }else{
          validate_contact_payload['groupid']       = "";
        }
        
        validate_contacts_worker.postMessage(validate_contact_payload);
      }
      
      validate_contacts_worker.onmessage = function(event) {
        
        if (event.data === parseInt(event.data, 10)){
          document.getElementById("progress").innerText = event.data;
          document.getElementById("progress-bar").style.width =  ""+Math.round(event.data / rawContactsLenght * 100)+"%";;
          document.getElementById("percentage").innerText = ""+Math.round(event.data / rawContactsLenght * 100)+"%";
        }else{


          if(document.getElementById("validated_contacts").innerText = JSON.stringify(event.data)){
            document.getElementById("validationComplete").click();
          }
          
          
          validate_contacts_worker.terminate();

        }
        
       
      };
      
    } else {
        //console.log("Sorry! No Web Worker support.");
    }

  }


  //==Validate Contacts
  contactsValidated(){
    var validated_contacts = JSON.parse(document.getElementById("validated_contacts").innerText);
    // //console.log(validated_contacts);
    
    //Send back the values
    this.validContacts.next(validated_contacts.validContacts);
    this.duplicateContacts.next(validated_contacts.duplicateContacts);
    this.failedContacts.next(validated_contacts.failedContacts);
    this.loading_uploads.next(false);
    this.flashInfo('Data Processing completed, Please review the data shown below before uploading');
          
  }

  //==Pre Validate/Read File Uploaded
  onFileChange(evt) {

    //Send back the loading signal
    this.loading_uploads.next(true);


    //Check if there was a file sent
    if(evt.target.files.length > 0){

      //get the filetype
      let fileType = evt.target.files[0].type;


      //Set the allowed file types that we can process at the moment.
      //Check if the file sent is of any of the file types we currently support
      if(this.AllowedFileTypes.includes(fileType)){
        
        /* wire up file reader */
        const target: DataTransfer = <DataTransfer>(evt.target);
        if (target.files.length !== 1){
          // throw new Error('Cannot use multiple files');
          // loading_uploads = false;
          this.flashWarning('Cannot use multiple files!');
          return;
        } 


        var read_contacts_worker;
        if(typeof(Worker) !== "undefined") {
          if(typeof(read_contacts_worker) == "undefined") {
            read_contacts_worker = new Worker("assets/workers/read_contacts.js");
            read_contacts_worker.postMessage(evt.target.files[0]);
          }
          read_contacts_worker.onmessage = function(event) {
            //console.log(event);
            this.varil = event.data;
            
            if(document.getElementById("uploaded_contacts").innerText = JSON.stringify(event.data)){
              document.getElementById("upc").click();
            }
            
            read_contacts_worker.terminate();
            
          };
        } else {
            //console.log("Sorry! No Web Worker support.");
        }
        
        
        }else{
          //send back a loading end signal
          this.loading_uploads.next(false);
          this.flashWarning('Filetype not supported!');
        }
    
    }else{
      //send back a loading end signal
      this.loading_uploads.next(false);
      this.flashWarning('No File Uploaded');
    }



  }
  ///// ==========================================================================///////////
  ///// ===========      END OF  CONTACT UPLOAD HELPERS           ================///////////
  ///// ==========================================================================///////////




  
  ///// ==========================================================================///////////
  ///// ===========              CONTACT EXPORT HELPERS           ================///////////
  ///// ==========================================================================///////////

  exportContacts(format, url){

    //Manually Display the Exporting Overlay since this can not be done with angular here.
    document.getElementById("exporting-overlay").style.display = "block";

    
    //Create the download function to download the blob data from the worker as Excel
    function dowmloadExcel(blob){
      //Manually remove the Exporting Overlay 
      document.getElementById("exporting-overlay").style.display = "none";
      //Use Filesaver to daownload the file to the users computer
      FileSaver.saveAs(new Blob([blob],{type:"application/octet-stream"}), 'contact-list.xlsx');
    
    }

    //Create the download function to download CSV string as csv file from the workser
    function dowmloadCSV(CSV){
      //Manually remove the Exporting Overlay 
      document.getElementById("exporting-overlay").style.display = "none";
      //Use Filesaver to daownload the file to the users computer
      FileSaver.saveAs(new Blob([CSV],{type:"text/csv"}), 'contact-list.csv');
    
    }


    //Fetch All contacts belonging to the current user
    this.api.get(url)
    .subscribe(
      res_data => {
      // //console.log(res_data.data);
      if(res_data.data){
        //console.log(res_data.data);
        // document.getElementById("full").innerText = res_data.data.length;
        
        //Start the Export worker
        var export_contacts_worker;
        if(typeof(Worker) !== "undefined") {
          if(typeof(export_contacts_worker) == "undefined") {
            export_contacts_worker = new Worker("assets/workers/export_contacts.js");

            //Send the Contacts to the worker
            export_contacts_worker.postMessage(res_data.data);
          }

          //Listen Fro any data that will be sent from the worker
          export_contacts_worker.addEventListener('message', function(e) {
        
            
            //Fire the download Action;
            switch (format) {
              case 'csv':
                dowmloadCSV(e.data.csv);
                break;
              case 'excel':
                dowmloadExcel(e.data.blob);
                break;
            };
            

          }, false);

          
          export_contacts_worker.onmessage = function(event) {


            // if (event.data === parseInt(event.data, 10)){
            //   document.getElementById("progress").innerText = event.data;
              

            //   // document.getElementById("progress-bar").stylevent.width =  ""+Math.round(event.data / res_data.data.length * 100)+"%";;
            //   // document.getElementById("percentage").innerText = ""+Math.round(event.data / res_data.data.length * 100)+"%";
            
            // }else{
    
    
            //   //Fire the download Action;
            //   switch (format) {
            //     case 'csv':
            //       dowmloadCSV(event.data.csv);
            //       break;
            //     case 'excel':
            //       dowmloadExcel(event.data.blob);
            //       break;
            //   };
              
            //   // export_contacts_worker.terminate();

            // }

            
            // //console.log(event.data);

            export_contacts_worker.terminate();
            
            
          };
          
        } else {
            //console.log("Sorry! No Web Worker support.");
        }



      }
      
    
      
      }, error_message => {
        //Error Handler Here
      }
    );

    

  }

  ///// ==========================================================================///////////
  ///// ===========      END OF  CONTACT EXPORT HELPERS           ================///////////
  ///// ==========================================================================///////////




  


  
}








// WEBPACK FOOTER //
// ./src/app/shared/helpers/helpers.service.ts